import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import * as Redux from 'react-redux';
import { logoColor } from '../../helpers/ImagesUtils';
import BotonComponent from '../dashboard/components/BotonNuevo';
import CarruselIntroComponent from './components/CarruselIntro';

const IntroView = () => {
  const dispatch = Redux.useDispatch();

  const templateStore = Redux.useSelector((state) => state.template);

  const [isNext, setIsNext] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <img alt="OnEDU" src={logoColor} width="70" />
          <Typography variant="h4" color="initial" sx={{ fontWeight: 'bold' }}>
            <label style={{ fontSize: '16pt', fontWeight: 'bold' }}>
              Más que una escuela, un aliado en tu camino hacia el éxito.
            </label>
          </Typography>
          <BotonComponent
            disabled={!isNext}
            click={() => {
              dispatch({
                type: 'SETTINGS_LAYOUT',
                payload: {
                  ...templateStore.settings,
                  intro: false,
                },
              });
            }}
            green
            text="Continuar"
            mb={2}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={12}>
        <CarruselIntroComponent
          onChange={(now, previus) => {
            setIsNext(now === 6);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default IntroView;
